// extracted by mini-css-extract-plugin
export var explainable = "_g1-a";
export var printerCard = "_g1-1";
export var printerCardConfigured = "_g1-2";
export var printerCardError = "_g1-3";
export var printerCardsContainer = "_g1-0";
export var printerIcon = "_g1-8";
export var printerIconConfigured = "_g1-5";
export var printerIconContainer = "_g1-4";
export var printerIconError = "_g1-6";
export var printerIconUnconfigured = "_g1-7";
export var workstationsTableCard = "_g1-9";